import React, { FC } from 'react'
import Script from 'next/script'

type TallyPopup = {
  width: number
  emoji?: {
    text: string
    animation: string
  }
  open: {
    trigger: 'time'
    ms: number
  }
  autoClose?: number
  showOnce?: boolean
  hideTitle?: boolean
  doNotShowAfterSubmit?: boolean
  hiddenFields?: Record<string, unknown>
}

const TallyEmbed: FC<{
  formId: string
  popup: TallyPopup
}> = ({ formId, popup }) => {
  return (
    <>
      <Script async src="https://tally.so/widgets/embed.js" />
      <Script
        id={`tally-config-${formId}`}
        dangerouslySetInnerHTML={{
          __html: `
            window.TallyConfig = {
              "formId": window.innerWidth >= 800 ? "${formId}" : undefined,
              "popup": ${JSON.stringify(popup)}
            }
          `,
        }}
      />
    </>
  )
}

export default TallyEmbed
